var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cadrePhoto"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('img',{staticClass:"photo",attrs:{"idPicture":_vm.prf.mainPicture.id,"src":_vm.prf.mainPicture.name}})]),_c('div',{staticClass:"dernierPseudo"},[_c('span',{staticClass:"pinklive"},[_vm._v(_vm._s(_vm.prf.pseudo))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }